// Ticket validation service
import Papa from 'papaparse';

class TicketValidationService {
  constructor() {
    this.validTickets = new Map();
    this.loadTickets();
  }

  async loadTickets() {
    try {
      const response = await fetch('/validTickets.csv');
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const csvText = await response.text();
      Papa.parse(csvText, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          if (results.errors.length > 0) {
          }
          
          results.data.forEach(ticket => {
            if (ticket.ticket_number && ticket.status === 'active') {
              this.validTickets.set(ticket.ticket_number, {
                name: ticket.name,
                email: ticket.email,
                company: ticket.company,
                role: ticket.role,
                status: ticket.status
              });
            }
          });
        },
        error: (error) => {
        }
      });
    } catch (error) {
      // Fallback: create some sample tickets if CSV fails
      this.createFallbackTickets();
    }
  }

  createFallbackTickets() {
    const fallbackTickets = [
      { ticket_number: 'WC2026-001', name: 'Sarah Johnson', email: 'sarah.johnson@techcorp.com', company: 'TechCorp', role: 'attendee', status: 'active' },
      { ticket_number: 'WC2026-002', name: 'Michael Chen', email: 'michael.chen@innovatelab.com', company: 'InnovateLab', role: 'attendee', status: 'active' },
      { ticket_number: 'WC2026-003', name: 'Emily Rodriguez', email: 'emily.rodriguez@dataflow.com', company: 'DataFlow', role: 'attendee', status: 'active' }
    ];
    
    fallbackTickets.forEach(ticket => {
      this.validTickets.set(ticket.ticket_number, {
        name: ticket.name,
        email: ticket.email,
        company: ticket.company,
        role: ticket.role,
        status: ticket.status
      });
    });
  }

  validateTicket(ticketNumber, email) {
    const ticket = this.validTickets.get(ticketNumber);
    
    if (!ticket) {
      return {
        valid: false,
        error: 'Invalid ticket number'
      };
    }
    
    // Check if email matches the ticket's email
    const ticketEmail = ticket.email?.toLowerCase().trim();
    const providedEmail = email?.toLowerCase().trim();
    
    if (ticketEmail !== providedEmail) {
      return {
        valid: false,
        error: 'Ticket number and email do not match'
      };
    }
    
    return {
      valid: true,
      ticketData: ticket
    };
  }

  getAllTickets() {
    return Array.from(this.validTickets.entries()).map(([ticketNumber, data]) => ({
      ticketNumber,
      ...data
    }));
  }
}

const ticketValidationService = new TicketValidationService();
export default ticketValidationService;
